import { formatCurrency } from '@hotel/shared/utils'
import { getAmenityList, getPrimaryImage } from '../api/client'
import { roomImageFallback } from './roomImageFallbacks'
import type { AvailabilityResult } from '../api/types'
import { PriceBreakdown } from './PriceBreakdown'
import { roomCapacityText } from './roomCapacityText'

export function RoomDetailModal({
  room,
  onClose,
  onBook,
}: {
  room: AvailabilityResult
  onClose: () => void
  onBook: () => void
}) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <img
          src={getPrimaryImage(room.images, roomImageFallback(room.name))}
          alt={room.name}
          className="modal-cover"
        />
        <div className="modal-content">
          <h3>{room.name}</h3>
          <p>{roomCapacityText(room.marketing_description || room.short_description, room.max_occupancy)}</p>
          <p>Capacidad: hasta {room.max_occupancy} huéspedes</p>
          <div className="chip-row">
            {getAmenityList(room.featured_amenities || room.amenities).map((amenity) => (
              <span key={amenity} className="chip">{amenity}</span>
            ))}
          </div>
          {room.highlights && room.highlights.length > 0 && (
            <ul className="highlights-list">
              {room.highlights.map((h) => <li key={h}>{roomCapacityText(h, room.max_occupancy)}</li>)}
            </ul>
          )}
          <p>Promedio por noche: {formatCurrency(room.estimated_nightly_rate)}</p>
          <PriceBreakdown pricing={room.pricing} />
          <div className="detail-price">
            <button className="primary-button" onClick={onBook}>Continuar reserva</button>
          </div>
        </div>
      </div>
    </div>
  )
}
